import { FC, memo } from 'react';
import Script from 'next/script';
import { convertQuery } from '../../../logics/JobContent/analytics';
import { appQueryParamsSelector } from '../../../redux/features/queryParams';
import { useAppSelector } from '../../../redux/hooks';

/**
 * 求人コンテンツ画面 PV計測のProps
 * @param pageName 画面名
 * @param channel チャンネル名
 */
interface Props {
  pageName: string;
  channel?: string;
}

export const PageViewAnalytics: FC<Props> = memo(({ pageName, channel }) => {
  // queryの取得
  const queryParams = useAppSelector(appQueryParamsSelector);
  const analyticsValue = convertQuery(queryParams);
  return (
    <Script>
      {`// AA
      if (!window.sc){
          window.sc = {};
      }
      sc.pageName="${pageName}"
      sc.channel="${channel ?? pageName}"
      sc.eVar195="${analyticsValue}"
      // GA
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
      'PageName': '${pageName}',
      'Channel': '${channel ?? pageName}'
      }); `}
    </Script>
  );
});

PageViewAnalytics.displayName = 'PageViewAnalytics';
